import React from 'react';
import PropTypes from 'prop-types';
import AsyncCreatableSelect from 'react-select/async-creatable';
import { components } from 'react-select';
import { getRequest } from '../../../requestUtils';
import './CompanyRegistrationDropdown.scss';

const formatError = (error) => (
  error
    ? (
      <p className="error-text">
        { error }
      </p>
    ) : ''
);

function MenuList({ children, ...props }) {
  return (
    <components.MenuList {...props}>
      {Array.isArray(children)
        ? children.slice(0, 10)
        : children}
    </components.MenuList>
  );
}

MenuList.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
};

const companyOptions = (term) => (
  getRequest(
    '/companies/autocomplete_dropdown',
    { term },
  ).then((response) => (
    response.data.map((i) => ({
      label: i.domain ? `${i.name} <${i.domain}>` : i.name,
      value: i.name,
    }))
  ))
);

class CompanyRegistrationDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
      value: props.value,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const { onChange } = this.props;
    const companyValue = e || { value: '', label: '' };
    this.setState({ menuOpen: false, value: companyValue.value });
    if (onChange) {
      onChange(companyValue);
    }
  }

  render() {
    const { error, creatable } = this.props;
    const { menuOpen } = this.state;

    return (
      <div
        id="company-dropdown"
        className="company-select"
        onKeyUp={() => { this.setState({ menuOpen: true }); }}
        onBlur={() => { this.setState({ menuOpen: false }); }}
        role="button"
        tabIndex={0}
      >
        <AsyncCreatableSelect
          id="company"
          className={`company-select-dropdown ${error ? 'error' : ''}`}
          name="user[company_user_attributes][company_attributes][name]"
          classNamePrefix="company-select"
          loadOptions={(input) => companyOptions(input)}
          placeholder="Company Name"
          onChange={this.handleChange}
          components={{ MenuList, IndicatorSeparator: () => null }}
          menuIsOpen={menuOpen}
          isValidNewOption={(opt) => creatable && opt.length}
          isClearable
        />
        { formatError(error) }
      </div>
    );
  }
}

CompanyRegistrationDropdown.propTypes = {
  error: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  creatable: PropTypes.bool,
};

CompanyRegistrationDropdown.defaultProps = {
  error: null,
  value: null,
  onChange: null,
  creatable: true,
};

export default CompanyRegistrationDropdown;
